// Supported checkout currencies for the WithMe platform.
// Keep this list in sync with backend pricing and CreatePriceStr.js.
export const SUPPORTED_CURRENCIES = [
   { code: 'GBP', label: 'British Pound',        symbol: '£' },
   { code: 'USD', label: 'US Dollar',             symbol: '$' },
   { code: 'EUR', label: 'Euro',                  symbol: '€' },
   { code: 'SEK', label: 'Swedish Krona',         symbol: 'kr' },
   { code: 'AUD', label: 'Australian Dollar',     symbol: 'AU$' },
   { code: 'CAD', label: 'Canadian Dollar',       symbol: 'CA$' },
   { code: 'NZD', label: 'New Zealand Dollar',    symbol: 'NZ$' },
];

export const SUPPORTED_CURRENCY_CODES = SUPPORTED_CURRENCIES.map((c) => c.code);

export const DEFAULT_CURRENCY = 'GBP';

export const getCurrencyByCode = (code) =>
   SUPPORTED_CURRENCIES.find((c) => c.code === code) || null;
